let appName = window.location.pathname.match('specialists') == null ? 'physicians' : 'specialists';

export const HEALTH_PLAN_TAG_COLOR_MAP = {
  'Wynn': 'purple',
  'RWLV': 'red',
  'GMG': 'green',
  'NV E':  'orange',
  'PHP': 'blue'
};
export const CPR_TASK_TYPES = [
    "cpr_response",
    "quality_measure_status_check",
    "cpr_status_check"
];

export const SUB_STATUSES_SHOW_DUE_DATE_SELECTOR = [
  'No show, CPR still required',
  'Canceled, CPR still required'
];

export const TAG_COLOR_MAP = {
  'patient-question': '#ff0069',
  'patient-reported-completed': '#ff0069',
  'patient-rejected': '#ff0069',
  'patient-requested-order': '#ff0069',
  'pcp-action-cpr-confirmation': '#1a237e',
  'pcp-action-order-needed': '#1a237e',
  'wp-action-visit-summary-check': '#00a1ff',
  'patient-action-verify-cpr-extension': '#304ffe',
  'patient-action-rejected-reason': '#304ffe',
  'vip-hotline': '#ba68c8',
  'unopened': '#b5bc00',
  'not-scheduled': '#bc5900',
  'cpr': '#ba68c8',
  'patient-action': '#304ffe',
  'wp-action': '#1a237e',
  'pcp-action': '#1a237e',
  'patient': '#ff0069',
  'new': '#ff9400',
  'established': '#189400',
  'PCP non-response': '#c0392b',
  "Request - Referral": '#e67e22',
  "Request - Order": '#e67e22',
  "Request - Resubmit Visit": '#e67e22',
  "Request - Review Claim": '#e67e22',
  'Retro-dated Referral': '#0088ff'
};

export const COLOR_SET = [
  "#FF5733", "#33FF57", "#3357FF", "#F1C40F", "#E67E22",
  "#E74C3C", "#8E44AD", "#3498DB", "#1ABC9C", "#2ECC71",
  "#9B59B6", "#34495E", "#F39C12", "#D35400", "#7F8C8D",
  "#2C3E50", "#16A085", "#27AE60", "#2980B9", "#8E44AD",
  "#F39C12", "#D35400", "#C0392B", "#8E44AD", "#F1C40F",
  "#E74C3C"
];

export const INIT_STATE = {
  isLoading: true,
  counts: {
    all_open_tasks: null,
    my_tasks: null,
    my_sent_tasks: null,
    on_hold_tasks: null,
    closed_tasks: null,
    abandoned_calls: null,
    voicemail_calls: null,
  },
  settings: {
    loaded: false,
    health_conditions: [],
    quality_measurement_types: [],
    all_sub_statuses: [],
    appointment_request_statuses: [],
    appointment_sources: [],
    cpr_status_list: [],
    general_patient_request_statuses: [],
    internal_communication_statuses: [],
    pcp_groups: [],
    pcps: [],
    support_agents: [],
    support_groups: [],
    visit_types: [],
  },
  activeView: "all_open_tasks",
  isViewLoading: false,
  isTaskSelected: false,
  showAllTasks: true,
  currentPage: 1,
  searching: false,
  query: {
    string: null,
    results: null,
    totalPages: null,
    totalTasks: null,
  },
  tasksPerPage: 50,
  totalPages: null,
  tags: [],
  appName: appName,
  filter: { value: "", label: "" },
  currentTask: {},
  isCreatingTask: false,
  create: { patient: {}, type: "" },
};

export const ADMIN_GROUP = "wellPORTAL Support";
export const SECONDARY_GROUP = "Prominence Support";
export const TASK_TYPES = [
  "Appointment Request",
  "Appointment Scheduled",
  "Appointment Completed",
  "Internal Communication",
  "General Patient Request",
  "Rx Request",
  "Patient Communication",
  "Order Request",
  "Specialist Referral"
];
export const SPECIALIST_TASK_TYPES = [
  "Patient Communication",
  "Specialist Referral"
];
export const TASK_LABELS = [
  { value: "", label: "-- Select label ---" },
  { value: "waiting_for_pcp", label: "Waiting for PCP" },
  { value: "waiting_for_patient", label: "Waiting for Patient" },
  { value: "unable_to_contact_patient", label: "Unable to Contact Patient" },
  { value: "waiting_for_wellportal", label: "Waiting for wellPORTAL" },
  { value: "waiting_for_health_plan", label: "Waiting for Health Plan" },

  { value: "other", label: "Other" },
];
export const TASKS_URL =
  "/physicians/api/tasks?task_type=appointment_request,rx_request,internal_communication,general_patient_request,cpr_response&appointment_request_status=appointment_request_created,pcp_appointment_request_received,pcp_contacted_patient,appointment_completed,visit_status_check,appointment_not_completed,pcp_denied_appointment_request";

export const ABANDONED_CALLS_URL = "/physicians/api/tasks?task_type=abandoned_calls";

export const VOICEMAIL_CALLS_URL = "/physicians/api/tasks?task_type=voicemail_calls";


export const SPECIALIST_FILTERS = [
  {
    label: "Specialist Referral",
    value: "/physicians/api/tasks?task_type=specialist_referral&status=open",
  },
  {
    label: "Patient Communication",
    value: "/physicians/api/tasks?task_type=patient_communication&status=open",
  },
  {
    label: "Internal Communication",
    value: "/physicians/api/tasks?task_type=internal_communication&status=open",
  },
];

export const APPOINTMENT_FILTERS = {
  label: "Appointments",
  options: [
    {
      value:
        "/physicians/api/tasks?task_type=appointment_request&appointment_request_status=appointment_request_created&status=open",
      label: "Appointment Request",
      task_type: "appointment_request",
      appointment_request_status: "appointment_request_created"
    },
    {
      value:
        "/physicians/api/tasks?task_type=appointment_request&appointment_request_status=appointment_confirmed&status=open",
      label: "Appointment Scheduled",
      task_type: "appointment_request",
      appointment_request_status: "appointment_confirmed"
    },
    {
      value:
        "/physicians/api/tasks?task_type=appointment_request&appointment_request_status=visit_status_check&status=open",
      label: "Appointment Status Check",
      task_type: "appointment_request",
      appointment_request_status: "visit_status_check"
    },
    {
      value:
        "/physicians/api/tasks?task_type=appointment_request&appointment_request_status=appointment_completed&status=open",
      label: "Appointment Completed (Open)",
      task_type: "appointment_request",
      appointment_request_status: "appointment_completed"
    },
    {
      value:
        "/physicians/api/tasks?task_type=appointment_request&appointment_request_status=appointment_completed&status=closed",
      label: "Appointment Completed (Closed)",
      task_type: "appointment_request",
      appointment_request_status: "appointment_completed"
    },
    {
      value:
        "/physicians/api/tasks?task_type=appointment_request&appointment_request_status=appointment_not_completed&status=open",
      label: "Appointment Not Completed",
      task_type: "appointment_request",
      appointment_request_status: "appointment_not_completed"
    },
  ],
};

export const OTHER_TASK_FILTERS = [{
  label: "CPR Patient Responses",
  value: "/physicians/api/tasks?task_type=cpr_response&status=open",
  task_type: "cpr_response",
},
{
  label: "General Patient Requests",
  value: "/physicians/api/tasks?task_type=general_patient_request&status=open",
  task_type: "general_patient_request"
},
{
  label: "Quality Measure Status Checks",
  value: "/physicians/api/tasks?task_type=quality_measure_status_check&status=open",
  task_type: "quality_measure_status_check"
},
{
  label: "Referral Requests",
  value: "/physicians/api/tasks?task_type=general_patient_request&status=open&general_patient_request_status=referral_request",
  task_type: "general_patient_request",
  general_patient_request_status: "referral_request"
},
{
  label: "Internal Communication",
  value: "/physicians/api/tasks?task_type=internal_communication&status=open",
  task_type: "internal_communication"
},
{
  label: "Patient Communication",
  value: "/physicians/api/tasks?task_type=patient_communication&status=open",
  task_type: "patient_communication"
},
{ label: "Rx Requests", value: "/physicians/api/tasks?task_type=rx_request&status=open" },
{
  label: "Order Requests",
  value: "/physicians/api/tasks?task_type=order_request&status=open",
  task_type: "order_request"
},
{
  label: "Voicemail Calls",
  value: "/physicians/api/tasks?task_type=voicemail_calls&status=open",
  task_type: "voicemail_calls"
},
{
  label: "Abandoned Calls",
  value: "/physicians/api/tasks?task_type=abandoned_calls&status=open",
  task_type: "abandoned_calls"
},
{
  label: "Specialist Referral",
  value: "/physicians/api/tasks?task_type=specialist_referral&status=open",
  task_type: "specialist_referral"
}];

export const DEFAULT_FILTERS = [
  APPOINTMENT_FILTERS
].concat(OTHER_TASK_FILTERS);

export const CPR_SUB_STATUS_OPTIONS = [
  {
    label: "Not Required",
    value: "closed-cpr_not_required",
  },
  { label: "Error", value: "closed-error" },
  {
    label: "Other",
    value: "closed-other",
  },
];
export const QUALITY_MEASUREMENTS_NEEDED = [
  "Blood Pressure",
  "HbA1c",
  "Kidney Function Test (Microalbumin/Creatinine Ratio)",
  "Total Cholesterol",
  "LDL Cholesterol",
];
export const CPR = {
  RESULTS_OBTAINED: "closed-completed_results_obtained",
  RESULTS_PENDING: "closed-completed_results_pending",
  VERIFIED_BY_CLAIMS: "CLOSED_-_COMPLETED_-_VERIFIED_BY_CLAIMS",
  CANCELED: "canceled - CPR required - resume notifications",
  NO_SHOW: "no show - CPR required - resume notifications",
  REQUIRED: "CPR required - resume notifications",
  RESCHEDULED: "closed-not-completed_rescheduled",
  PATIENT_REPORTED_COMPLETED: "patient_reported_completed",

  //prompts appointment scheduled form in visit status check
};

export const DEFAULT_COLOGUARD_ATTENDING_PROVIDER = 'Exact Sciences';

//sub status options in appointment not completed (TELL US WHY)
export const APPOINTENT_SUB_STATUS_OPTIONS = [
  {
    label: "Canceled, CPR still required",
    value: "canceled - CPR required - resume notifications",
  },
  {
    label: "No show, CPR still required",
    value: "no show - CPR required - resume notifications",
  },
  {
    label: "Patient Canceled, CPR not required",
    value: "closed - canceled - CPR not required",
  },
  {
    label: "CPR Not Required",
    value: "closed-cpr_not_required",
  },
  {
    label: "Patient Rescheduled",
    value: "closed-not-completed_rescheduled",
  },
  { label: "Error", value: "closed-error" },
  {
    label: "Other",
    value: "closed-other",
  },
];

export const VIEWS = [
  { label: "All Tasks", value: "all_tasks" },
  { label: "My Tasks", value: "my_tasks" },
  { label: "My Sent Tasks", value: "My Sent Tasks" },
];

export const TABLE_HEADERS = [
  // {
  //   label: "ID",
  //   name: "id",
  // },
  { label: "Task", name: "label", filterable: true },
  { label: "Priority", name: "priority" },
  { label: "Created", name: "created_at" },
  { label: "Patient", name: "name" },
  { label: "PCP Group", name: "pcp_group", filterable: true },
  { label: "Assignee", name: "assignee", filterable: true },
  { label: "Updated", name: "updated_at" },
];

export const RESPONSE_OUTCOMES = {
  completed: "PCP opened task in 15 minutes or less",
  notCompleted: "PCP did not respond in 15 minutes or less",
};
export const OUTREACH_OUTCOMES = {
  completed: "PCP completed patient outreach in 30 minutes or less",
  notCompleted: "PCP did not complete patient outreach in 30 minutes or less",
};

export const CLOSED_SUB_STATUSES = [
  { value: "closed-cpr_not_required" },
  { value: "closed - canceled - CPR not required" },
  { value: "closed-other" },
  { value: "closed-error" },
  { value: "closed-new_CPR_opened_with_appointment_date" },
  { value: "closed-completed_results_obtained" },
  { value: "closed-completed_results_pending" },
  { value: "closed_-_completed_-_verified_by_claims" },
];

export const KIDNEY_FUNCTION_REQUIRING_INPUT = [
  'Kidney Function Test (Microalbumin/Creatinine Ratio)',
  'Kidney Function Test (eGFR)',
];

export const KIDNEY_FUNCTION_TEST = [
  'Kidney Function Test (Microalbumin/Creatinine Ratio)',
  'Kidney Function Test (eGFR)',
  'Nephropathy Treatment',
  'Urine Protein Screening',
];

// both Kidney Function Test (Microalbumin/Creatinine Ratio) and Urine Protein Screening MUST be paired with a Kidney Function Test (eGFR)
export const KIDNEY_FUNCTION_TEST_COMBOS = [
  {
    label: 'Kidney Function Test (Microalbumin/Creatinine Ratio) + eGFR',
    quality_measurement_types: ['Kidney Function Test (Microalbumin/Creatinine Ratio)', 'Kidney Function Test (eGFR)']
  },
  {
    label: 'Urine Protein Screening + Kidney Function Test (eGFR)',
    quality_measurement_types: ['Urine Protein Screening', 'Kidney Function Test (eGFR)']
  },
  {
    label: 'Nephropathy Treatment',
    quality_measurement_types: ['Nephropathy Treatment']
  }
];

export const COLON_CANCER_SCREENING = [
  "Colon Cancer Screening",
  "Colonoscopy",
  "Sigmoidoscopy",
  "Cologuard",
  "High Sensitivity FOBT",
  "Fecal Immunochemical Test (FIT)",
];

export const LAB_QMS = [
  "HbA1c",
  "Total Cholesterol",
  "LDL Cholesterol",
  'Kidney Function Test (Microalbumin/Creatinine Ratio)',
  'Kidney Function Test (eGFR)',
  'Nephropathy Treatment',
  'Urine Protein Screening',
];

export const PRIMARY_CODE_QMS = [
  "Height",
  "Weight",
  "Body Mass Index (BMI)",
  "Blood Pressure",
  "Statin Therapy",
  "PHQ9",
  "Waist Measurement",
  "Fasting Glucose",
  "HDL Cholesterol",
  "Triglycerides",
];

export const CPR_ORDER_REQUEST =
  "An order/referral request was made for this care plan requirement. Please complete the fields below and attach the order document.";

export const CPR_ORDER_SUBMITTED =
  "An order/referral request for this care plan requirement was provided to the patient.";

export const CPR_STATUS_CHECK = {
  BODY_1: "We need your help verifying whether the patient completed the following Care Plan Requirement (CPR).",
  BODY_2: "Please check your records and answer the following question:",
  BODY_3: "Did the patient complete the requirement?",

  NOTE_1: "Note: if the patient completed the requirement more than once, enter the most recent measurement. If the patient completed the requirement ahead of schedule, enter it as well, provided it is the most recent measurement and within the required frequency for this quality measure."
};
export const QM_STATUS_CHECK = {
  BODY_1:
    "We need your help ensuring we have the most recent measurement for this patient to set their next due date.",
  MEASUREMENT_TYPE_TEXT: "According to our records, this patient's last ",
  CCS_TEXT: "According to our records, this patient had (a) ",
  CCS_COMPLETED_DATE_TEXT: " on the following dates: ",
  COMPLETED_DATE_TEXT: "was completed on",
  BODY_2: "Please check your records and answer the following questions:",
  PROMPT: "Is this the patient's most recent measurement?",
  FORM: {
    PROMPT: "Is this the patient's most recent measurement?",
    OPTIONS: [
      { label: "Yes", value: 1 },
      { label: "No", value: 2 },
    ],
  },
  SELECTED_VALUE_1:
    "Please provide an order/referral for this patient's next care plan requirement.",
  SELECTED_VALUE_2: "Please enter the most recent measurement details for this patient.",
};
